import React from 'react';
import { LocaleUtils } from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import DayPicker, { DateUtils } from 'react-day-picker/DayPicker';
import { formatDate, parseDate } from 'react-day-picker/moment';
import DatePickerRange from './DatePickerRange';
import { isValidDate, removeTime } from "../../helpers/dateTime";
import * as Tools from "../../helpers/Tools";

export default class DatePicker extends React.Component {
    constructor(props) {
        super(props);
        const { yearsBackward, yearsForward, touched, value, enabledDays } = this.props;
        const currentYear = new Date().getFullYear();
        let { minDate, maxDate } = this.props;
        let maxYear = yearsForward ? yearsForward : 100;

        if (!minDate && yearsBackward) {
            minDate = new Date(currentYear - yearsBackward, 0);
        }

        if (!maxDate && yearsForward) {
            maxDate = new Date(currentYear + yearsForward, 11);
        }

        let maxYeartoDisplay = new Date(currentYear + maxYear, 11);

        minDate = removeTime(minDate);
        maxDate = removeTime(maxDate);

        const months = LocaleUtils.getMonths();
        const years = [];

        if (minDate && maxDate) {
            for (let i = minDate.getFullYear(); i <= maxYeartoDisplay.getFullYear(); i += 1) {
                years.push(i);
            }
        }

        this.state = {
            months, years, selectedDay: undefined, month: undefined,
            valueEntered: false, touched: touched, isDateEmpty: value ? false : true,
            hasFocus: false, tabToNextDateField: false, prestine: true
        };

        this.isIos = false;
        this.isNumeric = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.isIos = Tools.isSafari() || Tools.isIos();
        if (this.props.autoFocus && this.dayPickerInput)
            this.dayPickerInput.input.focus();
    }

    componentDidUpdate() {
        if (this.props.focusBlankField && this.dayPickerInput)
            this.dayPickerInput.input.focus();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    isValid(value) {
        const { minDate, maxDate } = this.props;

        if (!value) {
            return false;
        }

        //if (!isValidDate(value)) {
        if (!Tools.isValidDate(value)) {
            return false;
        }

        //Check the date valid when entering manually
        if (!Tools.validateManualDate(value, 'MM/DD/YYYY')) {
            return false;
        }

        const dateValue = new Date(value);
        return (!minDate || dateValue >= minDate) && (!maxDate || dateValue <= maxDate);
    }

    handleKeyDown(e) {
        if (e.ctrlKey || e.altKey) {
            return;
        }

        const keyCode = e.keyCode;
        const inValid =
            keyCode === 111 || // the slash
            (keyCode > 64 && keyCode < 91) || // letter keys
            (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
            (keyCode > 218 && keyCode < 223);   // [\]' (in order)

        if (inValid) {
            e.preventDefault();
            return;
        }

        let target = e.target;
        let value = target.value;
        const key = e.key; //String.fromCharCode(e.which);
        let index = target.selectionStart;
        let prevChar = '';

        if (!/[0-9]/.test(key)) {
            this.isNumeric = false;
            if (keyCode === 9) { // tab key
                this.tab(target, e, !e.shiftKey);
                return;
            }
            else if (keyCode === 8) { // backspace
                if (target.selectionEnd > target.selectionStart) {
                    this.preserveTheSlash(e);
                }
                else if (value[index - 1] === '/') {
                    if (index === 1 || value[index - 2] === '/') {
                        target.selectionStart = target.selectionEnd = target.selectionStart - 1;
                    }
                    else {
                        //value = value.substring(0, index - 2);
                        //if (index < target.value.length - 1) {
                        //    value += target.value.substring(target.selectionEnd - 1);
                        //}
                        //target.value = value;
                        target.selectionStart = target.selectionEnd = index - 1;
                    }
                    //e.preventDefault();
                }
            }
            else if (keyCode === 46) { // delete key
                if (target.selectionStart > 0 || target.selectionEnd < target.value.length) {
                    if (target.selectionEnd > target.selectionStart + 1) {
                        this.preserveTheSlash(e);
                    }
                    else if (value[index] === '/') {
                        this.tab(target, e);
                    }
                }
            }
            return;
        } else {
            this.isNumeric = true;
        }

        let indexOfSlash2 = value.substring(0, target.selectionStart).lastIndexOf('/');
        if (index === 2 || (index === 5 && indexOfSlash2 === 5)) {
            this.tab(target, e);
            return;
        }

        if (index > 0) {
            prevChar = value[index - 1];
        }

        const indexOfSlash1 = value.indexOf('/');
        if (indexOfSlash1 > -1 && indexOfSlash1 < index) {
            indexOfSlash2 = value.indexOf('/', indexOfSlash1 + 1);
            if (indexOfSlash2 > -1 && indexOfSlash2 < index) {
                index += 5 - indexOfSlash2;
            }
            else {
                index += 2 - indexOfSlash1;
            }
        }

        if (index === 2 || index === 5) {
            this.tab(target, e);
            return;
        }

        const valid = (
            (index === 0 && /[0-1]/.test(key)) ||
            (index === 1 && ((prevChar === '0' && /[1-9]/.test(key)) || (prevChar === '1' && /[0-2]/.test(key)))) ||
            (index === 3 && /[0-3]/.test(key)) || (index === 4 && ((prevChar === '0' && /[1-9]/.test(key)) ||
                (/[1-2]/.test(prevChar) && /[0-9]/.test(key)) || (prevChar === '3' && /[0-1]/.test(key)))) ||
            (index >= 6 && index <= 9 && /\d/.test(key))
        );

        //const indexOfSlash21 = value.substring(0, target.selectionStart).lastIndexOf('/');
        //const end = indexOfSlash21 > -1 ? indexOfSlash21 : length;
        //const indexOfSlash12 = value.substring(0, end).lastIndexOf('/');
        //console.log(indexOfSlash21);
        //console.log(indexOfSlash12);
        //console.log(value);

        if (valid) {
            if (index < value.length && (index === 1 || index === 4)) {
                this.setState({ tabToNextDateField: true });
            }
            this.setState({ valueEntered: true });
        }
        else {
            e.preventDefault();
        }
    }

    onBlur() {
        const { valueEntered, touched } = this.state;
        if (this.props.required) {
            if (!valueEntered && !touched) {
                this.setState({ touched: true });
            }
        } else {
            if (valueEntered && !touched) {
                this.setState({ touched: true });
            }
        }
    }

    onLeave() {
        this.setState({ prestine: false });
    }

    handleContextMenu(e) {
        //    if (e.button === 2) {
        //        e.preventDefault();
        //    }
    }

    handleInputChange(e) {
        const { touched } = this.state;
        const target = e.target;
        let value = target.value;
        let month = '', day = '', year = '';
        let slashCount = 0;

        for (let i = 0; i < value.length; i++) {
            const char = value[i];
            if (char === '/') {
                slashCount++;
            }
            else if (/[0-9]/.test(char)) {
                if (slashCount === 0 && month.length < 2) {
                    month += char;
                }
                else if (slashCount <= 1 && day.length < 2) {
                    day += char;
                }
                else if (year.length < 4) {
                    year += char;
                }
                else {
                    break;
                }
            }
        }

        value = month;
        if (month.length === 2 || slashCount > 0) {
            value += '/';
        }

        value += day;

        if (day.length === 2 || slashCount > 1) {
            value += '/' + year;
        }

        target.value = value;

        let startcursorpos = -1;

        if (this.isIos) {
            for (let startpos = 0; startpos < value.length; startpos++) {
                const charValue = value[startpos];
                if (/[0-9]/.test(charValue)) {
                    startcursorpos = startpos;
                }
            }
            if (!(startcursorpos === 1 && target.selectionStart === 3)) {
                target.selectionStart = startcursorpos > -1 ? startcursorpos + 1 : 0;
                target.selectionEnd = target.selectionStart;
            }
        }

        //if (this.isNumeric) {
        //    if (month.length < 2) {
        //        target.selectionStart = month.length === 0 ? 0 : 1;
        //        target.selectionEnd = target.selectionStart;
        //    } else if (day.length < 2) {
        //        target.selectionStart = day.length === 0 ? 2 : 4;
        //        target.selectionEnd = target.selectionStart;
        //    } else if (year.length < 4) {
        //        target.selectionStart = year.length === 0 ? 5 : 6 + year.length;
        //        target.selectionEnd = target.selectionStart;
        //    }
        //}
        //if ((value.length === 2 || value.length === 3) && value.indexOf('/') > -1) {
        //    target.selectionStart = value.length - 1;
        //    target.selectionEnd = target.selectionStart;
        //} else if (value.length === 4 && value.indexOf('//') > -1) {
        //    target.selectionStart = value.length - 1;
        //    target.selectionEnd = target.selectionStart;
        //} else if(value.length === 5 && day.length < 2){
        //    target.selectionStart = value.length - 1;
        //    target.selectionEnd = target.selectionStart;
        //}
        //  }

        //set this value if we entered from keyboard.
        //if (value && !touched) {
        //    this.setState({ touched: true });
        //}

        if (this.state.tabToNextDateField) {
            this.setState({ tabToNextDateField: false });
            if ((this.isIos && !(startcursorpos === 1 && target.selectionStart === 3)) || !this.isIos) {
                this.tab(target, e);
            }
        }
    }

    preserveTheSlash(event) {
        const target = event.target;
        const start = target.selectionStart;
        const end = target.selectionEnd;
        let value = target.value;
        const indexOfSlash1 = value.indexOf('/', start);
        if (indexOfSlash1 > -1 && indexOfSlash1 < end) {
            let slash = '/';
            const indexOfSlash2 = value.indexOf('/', indexOfSlash1 + 1);
            if (indexOfSlash2 > -1 && indexOfSlash2 < end) {
                slash = '//';
            }

            //event.preventDefault();
            if (typeof window !== 'undefined') {
                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                const event2 = document.createEvent('Event'); //new Event('input', { bubbles: true });
                event2.initEvent('change', true, true);
                value = value.substring(0, start) + slash + value.substring(end);
                nativeInputValueSetter.call(target, value);
                target.dispatchEvent(event2);
                target.selectionStart = target.selectionEnd = start;
            }
        }
    }

    tab(target, event, clockwise = true) {
        const value = target.value;
        const length = value.length;

        if (length === 0) {
            return;
        }

        if (clockwise) {
            //debugger;
            // if (!this.isIos) {
            if (target.selectionStart < 5) {
                event.preventDefault();
            }
            const indexOfSlash1 = value.indexOf('/', target.selectionStart);
            const start = indexOfSlash1 > -1 ? indexOfSlash1 + 1 : 0;
            const indexOfSlash2 = value.indexOf('/', start);
            target.selectionStart = start;
            target.selectionEnd = indexOfSlash2 > -1 ? indexOfSlash2 : length;
            // }
        }
        else {
            if (target.selectionEnd > 3) {
                event.preventDefault();
            }
            const indexOfSlash2 = value.substring(0, target.selectionStart).lastIndexOf('/');
            const end = indexOfSlash2 > -1 ? indexOfSlash2 : length;
            const indexOfSlash1 = value.substring(0, end).lastIndexOf('/');
            target.selectionStart = indexOfSlash1 > -1 ? indexOfSlash1 + 1 : 0;
            target.selectionEnd = end;
        }
    }

    handleDayChange(day, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput() || dayPickerInput.state;
        this.setState({
            selectedDay: day,
            isDateEmpty: !input.value.trim()
        });
    }

    handleDayClick = (day, {selected, disabled}) => {
        this.setState({ selectedDay: day, valueEntered: true });
        if (this.props.onClick) {
            this.props.onClick(day, disabled);
        }
    }

    handleYearMonthChange(month) {
        //if (month < this.state.maxDate) //don't allow the user select future month/year which is greater than maxDate.
        //allowing user to select future month/year which is greater than maxDate since user may be selecting month before year and they'll get error feedback on input field
        this.setState({ month });

        if (this.props.onMonthChange) {
            this.props.onMonthChange(month);
        }
    }

    isDayDisabled(day, enabledDays, disabled) {
        if (disabled === true) {
            return true;
        }
        else {
            if (enabledDays.length > 0) {
                var disableDay = enabledDays.some(disabledDay =>
                    DateUtils.isSameDay(day, disabledDay)
                );
                return (!disableDay);
            }
        }
    }

    YearMonthForm({ date, months, years, onChange }) {
        const handleChange = function handleChange(e) {
            const { year, month } = e.target.form;
            if (year && month) {
                onChange(new Date(year.value, month.value));
            }
        };

        return (
            <form className="DayPicker-Caption">
                <select id="month_dtPicker" name="month" onChange={handleChange} value={date.getMonth()}>
                    {months.map((month, i) => (
                        <option key={month} value={i}>
                            {month}
                        </option>
                    ))}
                </select>
                <span className="icon-dd" />
                {years.length === 0 ?
                    <span>&nbsp;&nbsp;{date.getFullYear()}</span> :
                    <select id="year_dtPicker" name="year" onChange={handleChange} value={date.getFullYear()}>
                        {years.map(year => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>}
                {years.length === 0 ?
                    "" :
                    <span className="icon-dd" />
                }
            </form>
        );
    }

    clearInput = () => {
        if (this._isMounted) {
            this.setState({ isDateEmpty: true, touched: false, prestine: true }, () => {
                this.dayPickerInput.input.value = "";
                this.dayPickerInput.state.typedValue = ""; // making changes this way due to the existing open issue https://github.com/gpbl/react-day-picker/issues/977
                this.dayPickerInput.state.month = undefined;               
                this.props.onChange("");
            });
        }
    }    

    render() {
        const { month, months, years, isDateEmpty, prestine, hasFocus } = this.state;
        const { minDate, maxDate, value, dobId, required, isDateRange, placeholder, onChange, inputErrorMsg,
            isInline, selectedDays, className, disabled, initialDate, showAsInvalid, onFocus, dateIconNeeded = true, showClearBtn
        } = this.props;
        const isValid = prestine || (!required && isDateEmpty) || this.isValid(value);
        const validationClass = isValid && !showAsInvalid ? "" : " input-invalid";
        const dayPickerProps = {
            modifiers: { disabled: [{ after: maxDate }] },
            month: this.state.month === undefined ? (maxDate && maxDate < new Date() ? maxDate : new Date()) : month,
            fromMonth: initialDate || minDate,
            toMonth: maxDate,
            captionElement: ({ date }) => (
                <this.YearMonthForm
                    date={date} months={months} years={years}
                    onChange={(month) => this.handleYearMonthChange(month)}
                />
            ),
            labels: { nextMonth: "Next Month", previousMonth: "Previous Month" }
        };
        //minDate.setMonth(minDate.getMonth() + 1);
        //console.log("minDate", minDate);
        //console.log("initialDate", initialDate);
        return (isDateRange !== true
            ? isInline !== true
                ? <div className={"il-group datePickerInput" + (!isDateEmpty ? " input-not-empty" : "") + (className ? " " + className + " " : "") + (hasFocus ? " input-focused" : "") + validationClass}>
                    <DayPickerInput placeholder={placeholder ? placeholder : "Date of Birth (MM/DD/YYYY)"} format="MM/DD/YYYY" keepFocus={false}
                        onDayChange={(value, modifiers, input) => {
                            this.handleDayChange(value, modifiers, input);
                            this.setState({ valueEntered: true });
                            if (onChange) {
                                value = removeTime(typeof value !== 'undefined' ? value : input.input.value);
                                const isValid = this.isValid(value);
                                onChange(value, isValid);
                            }
                        }}
                        dayPickerProps={dayPickerProps} formatDate={formatDate} parseDate={parseDate}
                        inputProps={{
                            id: dobId, maxLength: 10, autoComplete: "off",
                            "aria-label": placeholder ? placeholder : "Date of Birth (MM/DD/YYYY)",
                            onContextMenu: e => this.handleContextMenu(e),
                            onChange: e => this.handleInputChange(e),
                            onKeyDown: e => this.handleKeyDown(e),
                            onFocus: (e) => { if (onFocus) onFocus(e); }
                            //onBlur: () => this.onBlur(),
                        }}
                        onDayPickerHide={() => this.onLeave()}
                        value={value || ""}
                        ref={element => (this.dayPickerInput = element)}
                    />
                    <div className="il-label" aria-hidden="true" style={{ pointerEvents: "none" }}>{placeholder ? placeholder : "Date of Birth (MM/DD/YYYY)"}</div>
                    {showClearBtn && value && value !== "//" &&
                        <div className={`clear-btn-container ${dateIconNeeded ? "datePicker-clear-btn" : ""}`}>
                            <button className="clear-btn" type="button" aria-label="clear button" onClick={e => this.clearInput(e)}><span className="icon-input-clear" /></button>
                        </div>
                    }
                    {dateIconNeeded && <div className="input-icon-append"><span className="icon-calendar-form" /></div>}
                    {!isValid && <div className="input-error-msg">{inputErrorMsg ? inputErrorMsg : (typeof value !== "undefined" && value) ? "Please enter a valid date of birth." : ""}</div>}
                </div>
                : <DayPicker
                    selectedDays={selectedDays ? selectedDays : this.state.selectedDay}
                    onDayClick={this.handleDayClick}
                    onMonthChange={(month) => this.handleYearMonthChange(month)}
                    disabledDays={day => this.isDayDisabled(day, this.props.enabledDays, disabled)}
                    month={initialDate || minDate}
                    fromMonth={minDate}
                    toMonth={maxDate}
                />
            : <div>
                <DatePickerRange />
            </div>
        );
    }
}